import { ESupplyStatus, ESupplyType, ESupplySubType } from '../models/supply'

export const onHanlderStatus = (status: number) => {
  switch (status) {
    case ESupplyStatus.INACTIVE:
      return $t('labels.supplyList.inactive')
    case ESupplyStatus.DEFAULT:
      return $t('labels.supplyList.default')
    case ESupplyStatus.ACTIVE:
      return $t('labels.supplyList.active')
    case ESupplyStatus.DISABLE:
      return $t('labels.supplyList.disable')
  }
}

export const onHanlderType = (type: string) => {
  switch (type) {
    case ESupplyType.FUEL:
      return $t('labels.supplyList.fuel')
    case ESupplyType.ASSETS_LARGE:
      return $t('labels.supplyList.assetsLagre')
    case ESupplyType.ASSETS_SMALL:
      return $t('labels.supplyList.assetsSmall')
    case ESupplyType.REPAIR_LARGE:
      return $t('labels.supplyList.repairLarge')
    case ESupplyType.REPAIR_SMALL:
      return $t('labels.supplyList.repairSmall')
  }
}

export const onHanlderSubType = (type: string) => {
  switch (type) {
    case ESupplySubType.MOOC:
      return $t('labels.supplyList.mooc')
    case ESupplySubType.OIL:
      return $t('labels.supplyList.oil')
    case ESupplySubType.WHEEL:
      return $t('labels.supplyList.wheel')
    case ESupplySubType.GENERATOR:
      return $t('labels.supplyList.generator')
    case ESupplySubType.CONTAINER:
      return $t('labels.supplyList.container')
    case ESupplySubType.CHARGE:
      return $t('labels.supplyList.charge')
  }
}
